<div>
    <mat-form-field class="custom-table-filter">
        <mat-label><mat-icon>filter_list</mat-icon>Filter by keyword e.g. Brand, Criticality, Sourcing
            Status</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input>
    </mat-form-field>

    <div class="custom-table-wrapper--inner" [ngClass]="{'custom-table-wrapper--scroll-within': isScrollWithinTable}">
        <ng-template #tooltipTemplateDisableItemSelect>
            <div class="custom-tooltip">
                <p>
                    You cannot select this item as it is not assigned to you.
                </p>
            </div>
        </ng-template>

        <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows #itemTableSort="matSort" matSort
            [dataSource]="itemDataSource">
            <ng-container matColumnDef="{{ column }}" *ngFor="let column of itemDisplayColumns">
                <div *ngIf="column === 'select'">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox tabindex="0" (click)="$event.stopPropagation()"
                            (keypress)="$event.stopPropagation()" (change)="$event ? toggleAllItemsRows() : null"
                            [checked]="hasSelectedItem() && isAllItemsSelected()"
                            [indeterminate]="hasSelectedItem() && !isAllItemsSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div [tp]="tooltipTemplateDisableItemSelect" tpClassName="custom-tooltip" tpMaxWidth="200px"
                            [tpInteractive]="true" tpPlacement="bottom" [tpIsEnabled]="row.isDisabled">
                            <mat-checkbox tabindex="0" (click)="$event.stopPropagation()"
                                (keypress)="$event.stopPropagation()" (change)="$event ? toggleItemRow(row) : null"
                                [checked]="isItemSelected(row)" [disabled]="row.isDisabled">
                            </mat-checkbox>
                        </div>
                    </td>
                </div>
                <div *ngIf="column === 'sourcingStatus'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sourcing Status</th>
                </div>
                <div *ngIf="column === 'purchaseExecutiveName'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Executive</th>
                </div>
                <div *ngIf="column === 'brand'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Brand</th>
                </div>
                <div *ngIf="column === 'displayItemNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Item No.</th>
                </div>
                <div *ngIf="column === 'materialSubGroup'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Material Sub-Group</th>
                </div>
                <div *ngIf="column === 'itemDescription'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Item Description</th>
                </div>
                <div *ngIf="column === 'quantity'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
                </div>
                <div *ngIf="column === 'unitOfMeasurement'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>UoM</th>
                </div>
                <div *ngIf="column === 'currency'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
                </div>
                <div *ngIf="column === 'unitPrice'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Unit Price</th>
                </div>
                <div *ngIf="column === 'totalAmount'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Item Amount</th>
                </div>
                <div *ngIf="column === 'partModelNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Part No./Model No.</th>
                </div>
                <div *ngIf="column === 'plannedDeliveryDate'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Planned Delivery Date</th>
                </div>
                <div *ngIf="column === 'criticality'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Criticality</th>
                </div>
                <div *ngIf="column === 'action'">
                    <th mat-header-cell *matHeaderCellDef
                        [ngClass]="{'is-hidden': !actionsType || actionsType.length === 0}"
                        class="table-cell--freeze-right">Action</th>
                </div>

                <div *ngIf="column !== 'select' && column !== 'action'">
                    <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </div>

                <div *ngIf="column === 'action'">
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'is-hidden': !actionsType || actionsType.length === 0}"
                        class="table-cell--freeze-right custom-table-icon-buttons">
                        <button (click)="onRowEditClick(element)"
                            *ngIf="actionsType?.includes(SelectItemTableAction.EDIT)"
                            type="button"><mat-icon>edit</mat-icon></button>
                        <button (click)="onRowDeleteClick(element)"
                            *ngIf="actionsType?.includes(SelectItemTableAction.DELETE)"
                            type="button"><mat-icon>remove_circle_outline</mat-icon></button>
                    </td>
                </div>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="itemDisplayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: itemDisplayColumns;"
                [ngClass]="{ 'custom-table-row--disabled': row.isDisabled }">
            </tr>
            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="100%" *ngIf="itemDataSource.data.length > 0">No data matching the filter
                    "{{input.value}}"</td>
            </tr>
        </table>
    </div>
    <mat-paginator #itemPaginator [pageSize]="defaultPageSize" (page)="onPaginatorPage($event)"
        [pageSizeOptions]="pageSizeOptions" showFirstLastButtons class="custom-table-paginator"></mat-paginator>

</div>